import React from 'react';

import { WhitePanel } from '../../../../components';
import { Group, Accordian, Question, Answer, Email, Call, SupportEmail, SupportCall } from './common';

export function AboutLukla() {
  return (
    <WhitePanel className="mb-4">
      <h2>About Lukla Flight</h2>
      <p>
        Lukla is the preferred gateway to the Everest Region, and the only way
        to get there is to take a flight from Kathmandu to Lukla. It is a short
        half an hour flight that passes pretty close to the mighty Himalayas and
        as you get close to Lukla, you will also get a beautiful view of
        Everest. Once on the ground, you will have to wait till you get to
        Kalapathar or Gokyo Ri for a comparable view!! So buckle your seat belts
        and get ready for Lukla!!
      </p>
      <p>
        However, make sure to hand carry a fleece as the elevation gain from
        Kathmandu to Lukla is around 1,500 meters or 5000 feet. This translates
        to a drop of 15 degree centigrade in temperature.
      </p>
    </WhitePanel>
  );
}

export function LuklaFAQ({ isOpen = true }) {
  return (
    <Accordian title="Top Questions" isOpen={isOpen}>
      <Group>
        <Question question="Will the flights take off from Kathmandu or Ramechhap?" />
        <Answer>
          For the spring season of 2022, the airlines have confirmed that the flight to Lukla will operate from Kathmandu.
        </Answer>
      </Group>
      <Group>
        <Question question="How much does a flight to Lukla cost?" />
        <Answer>
          The standard flight cost to Lukla from Kathmandu is USD 187. Our price of USD 170.60 is the lowest price you will find anywhere on the internet.
        </Answer>
      </Group>
      <Group>
        <Question question="What documents do I need to carry for boarding the flight to Lukla?" />
        <Answer>
          The airlines have removed the need for a vaccination certificate and PCR test report. So this will not be required. Here are the two things you will require: <br />
          <strong>Flight ticket:</strong> No need to print the ticket. You can show your e-ticket via any device like a phone or tablet. However, please make sure that you have downloaded the tickets and there’s no issue with the device battery.
          A government-issued identity card. Example: your driving license, passport, or citizenship.
        </Answer>
      </Group>
      <Group>
        <Question question="I am not a hundred percent sure about my return date, should I book a one-way flight ticket?" />
        <Answer>
          It is better to get a two-way flight even though you aren’t sure about your return date. The reasons are pretty simple: rescheduling is free and super easy with HoneyGuide, and booking early gives you a better shot at getting earlier flights.
          For rescheduling support, WhatsApp us at +977-9810102745 once you reach Namche, and we will shift your return flights.
        </Answer>
      </Group>
      <Group>
        <Question question="How do I prepare for possible flight disruptions?" />
        <Answer>
          Most flights in the Himalayas are highly weather-dependent, and the best approach is to factor in the possible delays in your itinerary. The idea is to have a few buffer days after your flight out of Lukla to factor in any possible disruptions. Here is an estimate:<br />
          - February-May: 2 days<br />
          - June-August: 3 days<br />
          - September-October: 2 days<br />
          - November-January: 1 day<br />
          - Another significant way to insure against flight disruptions is to book early and try to get the first or second flight.
        </Answer>
      </Group>

      <Group>
        <Question question="Who do I contact in case of any issues?" />
        <Answer>
          If you have booked your flights through HoneyGuide, we will be there at your service 24-7. You can write to us at <Email /> or call / WhatsApp us at <Call />.
        </Answer>
      </Group>

      <Group>
        <Question question="What are my flight booking and payment options?" />
        <Answer>
          The standard way of booking your flight is through HoneyGuide’s website. To book <a href='https://honeyguideapps.com/flights' target='_blank' rel="noopener noreferrer">https://honeyguideapps.com/flights</a> However, if you cannot book your flight online, you can write to us at <Email /> or call / WhatsApp us at <Call />.
        </Answer>
      </Group>

      <Group>
        <Question question="Is the flight to Lukla safe?" />
        <Answer>
          Given the topography, weather, location, size of the airport, and traffic volume, Lukla airport is considered the world's most dangerous. But with 55 fatalities between 2003 and 2018, and 1,448,251 passengers carried in the same period, your chances of dying are 1 out of 26,331. The lifetime odds of dying in a motor vehicle accident in the US is at an astounding 1 out of 103! Sure, this is not a legit comparison, but if you take Lukla flight as a once in a lifetime thing, the odds for Lukla look even better. Given that, the flight authorities are very strict regarding flights to Lukla. They delay or cancel the flight even if there is a slight change in the weather, avoiding any risk or danger. This shows that the flight to Lukla is safe. To learn more, <a href='https://honeyguideapps.com/blog/lukla-airport-5-things-you-probably-didnt-know'>https://honeyguideapps.com/blog/lukla-airport-5-things-you-probably-didnt-know</a>
        </Answer>
      </Group>
      {/* ------------------------------------------------------------ */}
      <Group>
        <Question question="What is the baggage allowance for a flight to Lukla?" />
        <Answer>
          Check-in Baggage: 10 kilograms / 22 pounds. 2 pieces tops. Hand Carry: 5 kilograms / 11 lbs. Excess baggage is charged at the rate of USD 1 per kg.
        </Answer>
      </Group>

      <Group>
        <Question question="Do I need to confirm my flight booking?" />
        <Answer>
          No. Once your flight is booked, you do not need to reconfirm it. As soon as the booking process is complete, we will send you an email with an e-ticket and the necessary details of your confirmed booking. You are requested to check your spam folder as well. If you do not receive tickets within 30 minutes, please email us at <Email /> or call / WhatsApp us at <Call />.
        </Answer>
      </Group>

      <Group>
        <Question question="Do I need to print my ticket?" />
        <Answer>
          No. You can show your e-ticket at the Airport Counter via any device like a phone or tablet. However, please make sure that you have downloaded the tickets and there’s no issue with the device battery.
        </Answer>
      </Group>

      <Group>
        <Question question="How early should I get to the Airport for catching my Lukla flight?" />
        <Answer>
          It is advised to reach the airport one and a half hours before the flight time.
        </Answer>
      </Group>
    </Accordian>
  );
}

export function RamechhapFAQ({ isOpen = true }) {
  return (
    <Accordian title="Ramechhap Flight Details" isOpen={isOpen}>
      <Group>
        <Question question="Does USD 145.76 include transportation from Kathmandu to Ramechhap, and back? " />
        <Answer>
          Yes. USD 145.76 includes transportation as well. Besides, you also get HoneyGuide credit worth USD 5 per ticket. You can use it to book lodges and guides from HoneyGuide’s system.
        </Answer>
      </Group>
      <Group>
        <Question question="What kind of vehicle will be arranged?" />
        <Answer>
          The vehicle will be either a car, jeep, or a hiace/microvan depending on the number of people traveling that day.
        </Answer>
      </Group>
      <Group>
        <Question question="Where will the vehicle depart from? And at what time?" />
        <Answer>
          <strong>From Kathmandu to Ramechhap:</strong> The vehicle will leave from <a href="https://goo.gl/maps/CNMcmjhZqkn9VA3s6">Employees Provident Fund Building</a>, Thamel in Kathmandu and drop you at Ramechhap Airport. The general departure time from Kathmandu is 2 am (can be an hour ahead in case of earliest flight). You are requested to arrive 15 minutes before the departure time. <br />
          <strong>From Ramechhap to Kathmandu:</strong> The vehicle will depart at around 10 am (or later depending on when you land) and drop you off at <a href="https://goo.gl/maps/CNMcmjhZqkn9VA3s6">Employees Provident Fund Building</a> in Thamel. The driver contacts will be communicated to you a day ahead via WhatsApp. You are advised to be in touch once you reach Lukla.
        </Answer>
      </Group>
      <Group>
        <Question question="Will the vehicle pick me up from my hotel?" />
        <Answer>
          No. The vehicle departure location is in the most central point in Thamel (which should be more than 10 minutes walk from any hotels in and around Thamel). Alternatively, you can ask your hotel to drop you off at the pickup location.
        </Answer>
      </Group>
      <Group>
        <Question question="Will I get vehicle details with the flight tickets?" />
        <Answer>
          You will receive transportation confirmation in the same email with the flight tickets. However, the details like driver’s contact and vehicle number will be sent to you a day before your flight. The driver will have your details, and you can simply show them your flight tickets.
        </Answer>
      </Group>
    </Accordian>
  );
}


// WEBPACK FOOTER //
// ./src/screens/Flights/SearchAndResults/StaticSections/Lukla.js